import { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import DocumentRenameComponent from "./DocumentRenameComponent";
// import BottomContentSideBar from "./BottomContentSideBar";
import PropTypes from "prop-types";
import { useReactToPrint } from "react-to-print";
import { saveAs } from "file-saver";

// import avatarImg from "../../../assets/images/avatar.svg";
import { calculateAge, formatCalendarDate, mediaRoute } from "../../../Utils/helper";
import api, { api_without_cancellation } from "../../../api/api";
import {
  PageInfo,
  UserProfile,
} from "../../common/CustomModal/CustomModalSidebar/ModalSideBarUserInfo";
import NewChatIcon from "../../../assets/NewChatIcon";
import CustomRenameComponent from "../../common/CustomModal/CustomModalSidebar/CustomRenameComponent";
import BottomContentSideBar from "../../common/CustomModal/CustomModalSidebar/CustomModalBottomContentSidebar";
import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
// eslint-disable-next-line import/no-unresolved
import UploadIcon from "/public/bp_assets/img/cloud_icon.svg";
import mixColorWithWhite from "../../TreatmentPage/utils/helperFn";
// import UserChatBubble from "../../Forms/FirmUserBtn";

import ChatPhotoModal from "./ChatPhotoModal";

function toSentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const DocumentModalSideBar = ({
  documentData,
  documentURL,
  hideDocumentModal,

  imageRef,
  documentURLfordownload,
  slotsData,
  onRefetchSlotsData,
  loading,
  setSlotsData,
  firms,
  selectedFirm,
  users,
  chatLoading,
  chatError,
  handleSelectFirm,
  sendMessage,
  searchUsers,
  setChatDocumentThread,
  setUpdatedUser,
  handleSelectUser,
}) => {
  const {
    id: docId,
    for_client: clientInfo,
    for_case: caseInfo,
    title: file_name,
    // date_uploaded: dateUploaded,
    // docDate,
    // attached_by: attachUser,
  } = documentData;
  const [showMenuBar, setShowMenuBar] = useState(false);
  const [panelMenuBar, setPanelMenuBar] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [error, setError] = useState(null);
  const handleDownload = async () => {
    try {
      const response = await api_without_cancellation.get(
        `${mediaRoute(documentURL)}?timestamp=${new Date()}`,
        {
          responseType: "blob",
          withCredentials: false,
        }
      );
      const blob = response?.data;
      const objectURL = URL.createObjectURL(blob);
      saveAs(objectURL, file_name);
    } catch (error) {
      console.error("Error fetching or processing the blob:", error);
    }
  };
  const handleDelete = async (docId) => {
    try {
      await handleDownload(docId);
      await api.delete(`api/delete-photo-doc/?photo_id=${docId}`, {
        check: "Delete",
      });

      hideDocumentModal();
      // window.location.reload(true);
    } catch (error) {
      console.error("Failed to delete photo:", error.response?.data || error.message);
    }
  };
  const handlePrint = useReactToPrint({
    content: () => imageRef.current,
  });

  const buttonData = [
    {
      label: "Print",
      className: "btn btn-primary col height-25 d-flex align-items-center justify-content-center",
      onClick: handlePrint,
    },
    {
      label: "Download",
      className:
        "btn btn-primary download-btn col height-25 d-flex align-items-center justify-content-center",
      onClick: handleDownload,
    },
    {
      label: "Email",
      className: "btn btn-primary col height-25 d-flex align-items-center justify-content-center",
      onClick: () => {},
    },

    {
      label: "Delete",
      className:
        "btn btn-secondary height-25 d-flex align-items-center justify-content-center flex-g",
      onClick: handleDelete,
    },
  ];

  // const matchingSlot = slotsData.find((slot) =>
  //   slot.page_docs?.some((doc) => doc.id === documentData.id)
  // );

  // const matchExactSlott = matchingSlot?.page_docs?.find((doc) => doc.id === documentData.id);

  // const panelWithDocument = matchingSlot?.panels?.find((panel) =>
  //   panel.photos?.some((doc) => doc.id === documentData?.id)
  // );

  const matchingSlot = slotsData.find((item) => {
    if (!item.page?.panels) {
      return item.slots?.some((slot) => slot.photos?.some((doc) => doc.id === documentData.id));
    }
    const slot0 = item.slots?.find((slot) => slot.slot_number === 0);
    if (slot0?.photos?.some((doc) => doc.id === documentData.id)) {
      return true;
    }

    return item.panels?.some((panel) => panel.photos?.some((doc) => doc.id === documentData.id));
  });

  // Find the exact slot/panel and document
  let matchExactSlott = null;
  let panelWithDocument = null;

  if (matchingSlot) {
    if (!matchingSlot.page?.panels) {
      for (const slot of matchingSlot.slots || []) {
        const foundDoc = slot.photos?.find((doc) => doc.id === documentData.id);
        if (foundDoc) {
          matchExactSlott = foundDoc;
          break;
        }
      }
    } else {
      // panels is true - check slot where slot_number === 0, then panels
      const slot0 = matchingSlot.slots?.find((slot) => slot.slot_number === 0);
      matchExactSlott = slot0?.photos?.find((doc) => doc.id === documentData.id);
      if (!matchExactSlott) {
        panelWithDocument = matchingSlot.panels?.find((panel) =>
          panel.photos?.some((doc) => doc.id === documentData.id)
        );
        if (panelWithDocument) {
          matchExactSlott = panelWithDocument.photos?.find((doc) => doc.id === documentData.id);
        }
      }
    }
  }

  const [documentPanelsData, setDocumentPanelsData] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div
      className="right-sidebar d-flex flex-column"
      style={{ minWidth: "220px", zIndex: "1", width: "220px" }}
    >
      <div className="bluish-effect" />
      <div className="d-flex flex-column justify-content-between h-100">
        <div className="top-content">
          <span
            className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            CASE
          </span>
          <div
            className="client-name d-flex align-items-center side-bar-padding"
            style={{ height: "25px", background: "white" }}
          >
            <UserProfile clientInfo={clientInfo} />
          </div>

          <div className="basic-info m-r-0 m-l-0">
            {/* Basic info content */}
            <div
              className="tile-row w-100 p-l-5 p-r-5 d-flex align-items-center justify-content-between"
              style={{ height: "21px", background: "var(--primary-4)" }}
            >
              <div className="d-flex align-items-center" style={{ height: "21px" }}>
                <span
                  className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                  style={{ marginRight: "5px" }}
                >
                  <img
                    src={birthdayIcon}
                    className=""
                    style={{
                      width: "15px",
                      height: "15px",
                    }}
                  />
                </span>

                <p className="text-black font-weight-semibold d-block">
                  {formatCalendarDate(clientInfo?.birthday) || ""}
                </p>
              </div>
              <div className="d-flex align-items-center" style={{ height: "21px" }}>
                <span
                  className=" text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                  style={{ marginRight: "5px" }}
                >
                  Age
                </span>

                <p className="font-weight-semibold">{calculateAge(clientInfo?.birthday)}</p>
              </div>
            </div>
            <div
              className="tile-row w-100 p-l-5 p-r-5 d-flex flex-column"
              style={{ height: "42px", background: "var(--primary-2)" }}
            >
              <div className="d-flex align-items-center" style={{ height: "21px" }}>
                {caseInfo?.case_type?.casetype_icon && (
                  <span
                    className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                    style={{ marginRight: "5px" }}
                  >
                    <img
                      style={{
                        width: "15px",
                        height: "15px",
                      }}
                      src={caseInfo?.case_type?.casetype_icon}
                      alt="icon"
                    />
                  </span>
                )}

                <p className="text-black font-weight-semibold d-block">
                  {caseInfo?.case_type?.name || "N/A"}
                </p>
              </div>
              <div className="d-flex align-items-center" style={{ height: "21px" }}>
                <span
                  className="ic-avatar ic-15 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                  style={{ marginRight: "5px" }}
                >
                  <img
                    src={incidentIcon}
                    className=""
                    style={{
                      width: "15px",
                      height: "15px",
                    }}
                  />
                </span>

                <p className="font-weight-semibold">
                  {formatCalendarDate(caseInfo?.incident_date) || "N/A"}
                </p>
              </div>
            </div>

            <span
              className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
              style={{
                fontSize: "14px",
                height: "25px",
                borderRadius: "0px",
              }}
            >
              PHOTO NAME
            </span>

            <CustomRenameComponent
              initialDocumentName={file_name}
              docId={docId}
              apiEndpoint="/api/rename-photo-doc/"
              isPdf={false}
            />

            <span
              className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
              style={{
                fontSize: "14px",
                height: "25px",
                borderRadius: "0px",
              }}
            >
              LOCATION
            </span>
            <div
              className="d-flex align-items-start justify-content-between m-b-0"
              style={{
                background: "white",
                height: "63px",
              }}
            >
              <div
                className="tile-row d-flex align-items-center justify-content-start flex-wrap w-100 align-items-center"
                style={{
                  minHeight: "21px",
                  maxHeight: "63px",
                  overflow: "hidden",
                  overflowWrap: "break-word", // ensures wrapping inside
                  whiteSpace: "normal", // allows wrapping of long words
                }}
              >
                <PageInfo
                  page={matchingSlot?.page || {}}
                  documentSlot={matchExactSlott?.photo_slot}
                  panel={panelWithDocument}
                  file_name={file_name}
                />
              </div>
            </div>
          </div>

          <div>
            <span
              className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
              style={{
                fontSize: "14px",
                height: "25px",
                borderRadius: "0px",
              }}
            >
              MOVE PHOTO
            </span>
            {loading ? (
              <div>
                <style>{`
               @keyframes shimmer {
                 0% {
                   background-position: -1000px 0;
                 }
                 100% {
                   background-position: 1000px 0;
                 }
               }
               .shimmer-effect {
                 animation: shimmer 2s infinite linear;
                 background: linear-gradient(
                   90deg,
                   transparent 0%,
                   rgba(255, 255, 255, 0.3) 50%,
                   transparent 100%
                 );
                 background-size: 1000px 100%;
               }
             `}</style>

                <ul className="d-block document-pop-up-menu-sidebar" style={{ paddingLeft: "0px" }}>
                  {[1, 2, 3, 4, 5, 6, 7].map((index) => (
                    <li key={index} className="">
                      <a
                        className="cursor-pointer d-flex align-items-center shimmer-effect relative overflow-hidden"
                        style={{
                          height: "25px",
                          backgroundColor:
                            index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                        }}
                      >
                        <div
                          className="absolute inset-0"
                          style={{
                            animation: "shimmer 2s infinite linear",
                            background:
                              "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                            backgroundSize: "1000px 100%",
                          }}
                        />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <ul className="d-block document-pop-up-menu-sidebar" style={{ paddingLeft: "0px" }}>
                {slotsData &&
                  slotsData.map((slotData) => {
                    // Find the corresponding slot data for the current page
                    if (slotData.page?.is_notes_category && slotData && slotData.slots.length > 0) {
                      const { page, panels, slots: page_slots } = slotData;

                      if (page_slots.length > 0 && page.name === "Treatment" && page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(0px, -20px)",
                                right: width > 1400 ? "220px" : "220px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "35px",
                                    // padding: "0 10px",
                                    paddingTop: "0px",
                                    paddingLeft: "25px",
                                    paddingRight: "10px",
                                    paddingBottom: "0px",
                                    // background: "white",
                                    cursor: "pointer",
                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      photo_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id === documentData?.photo_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.photos?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.photos?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                photos:
                                                  slot.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                photos:
                                                  panel.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  photos: [
                                                    ...(s.photos || []),
                                                    updatedDocumentData,
                                                  ],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              photos: [...(panel.photos || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      const pageNameToModelName = {
                                        treatment: "CaseProviders",
                                        defendant: "Defendant",
                                        witnesses: "Witness",
                                        insurance: "Insurance",
                                        parties: "OtherParty",
                                        reports: "Reports",
                                        employment: "Employment",
                                        loans: "CaseLoan",
                                        discovery: "Discovery",
                                        recording: "Recordings",
                                        experts: "CaseExpert",
                                        Litigation: "LitigationAct",
                                      };

                                      const modelName =
                                        pageNameToModelName[page?.name?.toLowerCase()];
                                      await api_without_cancellation.post(
                                        "api/attach_photo_to_page/",
                                        {
                                          panel_id: null,
                                          slot_id: slot.id,
                                          page_id: page.id,
                                          case_id: documentData?.for_case?.id,
                                          photo_id: docId,
                                          ...(modelName && {
                                            model_name: modelName,
                                          }),
                                        }
                                      );
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="d-flex bg-primary-5 align-items-center"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "capitalize",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center color-grey-2"
                                    style={{ gap: "0px", width: "100%" }}
                                  >
                                    {/* <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    ></span> */}
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {panelIndex + 1}
                                    </span>
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {/* <img
                                        src={TFIcon}
                                        alt="tf-icon"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                          position: "relative",
                                          right: "0px",
                                          bottom: "0px",
                                        }}
                                      /> */}
                                    </span>

                                    <span
                                      className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                        width: "calc(100% - 25px)",
                                        background: mixColorWithWhite(panel?.specialty?.color, 10),
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: panel?.specialty?.color,

                                          fontSize: "16px",
                                          fontWeight: "700",
                                          height: "25px",
                                          width: "25px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "white",
                                          marginRight: "5px",
                                        }}
                                      >
                                        {panel?.specialty?.name[0] ?? ""}
                                      </span>
                                      {panel?.panel_name ? panel.panel_name : ""}
                                    </span>
                                  </a>
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "250px",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 0}%)`
                                          : `translate(0px, -${panelIndex + 3}%)`,
                                      // right: "17.2%",
                                      right: "89%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                          background: documentData
                                            ? mixColorWithWhite(
                                                documentPanelsData?.specialty?.color,
                                                10
                                              )
                                            : "",
                                        }}
                                      >
                                        <span
                                          style={{
                                            background: documentPanelsData?.specialty?.color,
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            height: "25px",
                                            width: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "white",
                                            marginRight: "5px",
                                          }}
                                        >
                                          {documentPanelsData?.specialty?.name[0] ?? ""}
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    <li
                                      className="d-flex bg-primary-5 align-items-center justify-content-center"
                                      style={{
                                        height: "25px",
                                        // background: "var(--primary-15)",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center justify-content-center whitespace-nowrap p-r-5 p-l-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "var(--primary)",
                                          width: "100%",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Photo Slot Buttons
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.photos?.filter(
                                        (doc) => doc.photo_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          photo_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.photos?.some((doc) => doc.id === documentData.id)
                                          );
                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.photos?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });
                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.photos?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.photos?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.photos?.some(
                                                (doc) => doc.id === documentData.id
                                              )
                                            );
                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    photos:
                                                      slot.photos?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        photos: [
                                                          ...(panel.photos?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      photos: [
                                                        ...(panel.photos || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          const pageNameToModelName = {
                                            treatment: "CaseProviders",
                                            defendants: "Defendant",
                                            witnesses: "Witness",
                                            insurance: "Insurance",
                                            parties: "OtherParty",
                                            reports: "Reports",
                                            employment: "Employment",
                                            loans: "CaseLoan",
                                            discovery: "Discovery",
                                            recording: "Recordings",
                                            experts: "CaseExpert",
                                            Litigation: "LitigationAct",
                                          };

                                          const modelName =
                                            pageNameToModelName[page?.name?.toLowerCase()];
                                          await api_without_cancellation.post(
                                            "api/attach_photo_to_page/",
                                            {
                                              panel_id: panel.id,
                                              slot_id: slot.id,
                                              page_id: page.id,
                                              case_id: documentData?.for_case?.id,

                                              photo_id: docId,
                                              ...(modelName && {
                                                model_name: modelName,
                                              }),
                                            }
                                          );
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              background:
                                                slotIndex % 2 === 0
                                                  ? mixColorWithWhite(panel?.specialty?.color, 2)
                                                  : mixColorWithWhite(panel?.specialty?.color, 4),
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-15 ic-photos cursor-pointer "
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center whitespace-nowrap  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",

                                                  // height: "25px",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].title
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      if (page_slots.length > 0 && page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(0px, -20px)",
                                right: width > 1400 ? "220px" : "220px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      photo_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id === documentData?.photo_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.photos?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.photos?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                photos:
                                                  slot.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                photos:
                                                  panel.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  photos: [
                                                    ...(s.photos || []),
                                                    updatedDocumentData,
                                                  ],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              photos: [...(panel.photos || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      const pageNameToModelName = {
                                        treatment: "CaseProviders",
                                        defendant: "Defendant",
                                        witnesses: "Witness",
                                        insurance: "Insurance",
                                        parties: "OtherParty",
                                        reports: "Reports",
                                        employment: "Employment",
                                        loans: "CaseLoan",
                                        discovery: "Discovery",
                                        recording: "Recordings",
                                        experts: "CaseExpert",
                                        Litigation: "LitigationAct",
                                      };

                                      const modelName =
                                        pageNameToModelName[page?.name?.toLowerCase()];
                                      // await api_without_cancellation.post("api/doc/attach/", {
                                      //   panel_id: "",
                                      //   slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                      //   page_id: page.id,
                                      //   case_id: documentData?.for_case?.id,
                                      //   panels: true,
                                      //   doc_id: docId,
                                      // });
                                      await api_without_cancellation.post(
                                        "api/attach_photo_to_page/",
                                        {
                                          panel_id: null,
                                          slot_id: slot.id,
                                          page_id: page.id,
                                          case_id: documentData?.for_case?.id,
                                          photo_id: docId,
                                          ...(modelName && {
                                            model_name: modelName,
                                          }),
                                        }
                                      );

                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="d-flex bg-primary-5 align-items-center"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center"
                                    // style={{ gap: "5px" }}
                                    style={{
                                      color: "var(--primary-25)",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    />
                                    <span className="ms-2" style={{ fontWeight: "bold" }}>
                                      {panelIndex + 1}.
                                    </span>
                                    <span
                                      className="ms-2 whitespace-nowrap"
                                      style={{
                                        fontWeight: "bold",
                                        color: "var(--primary)",
                                      }}
                                    >
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a>
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "auto",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 0}%)`
                                          : `translate(0px, -${panelIndex + 3}%)`,
                                      // right: "17.2%",
                                      right:
                                        page?.name === "Employment"
                                          ? "89%"
                                          : page?.name === "Reports"
                                            ? "89%"
                                            : page?.name === "Defendant"
                                              ? "89%"
                                              : page?.name === "Insurance"
                                                ? "89%"
                                                : page?.name === "Experts"
                                                  ? "88%"
                                                  : "90%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="p-l-5 d-flex align-items-center"
                                          style={{
                                            width: "25px",
                                            height: "25px",
                                          }}
                                        >
                                          <img
                                            src={page.page_icon ?? ""}
                                            className=" d-flex align-items-center justify-content-center cursor-pointer"
                                            // className="document-icons-width"
                                            alt=""
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    <li
                                      className="d-flex bg-primary-5 justify-content-center align-items-center"
                                      style={{
                                        height: "25px",
                                        // background: "var(--primary-15)",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center justify-content-center whitespace-nowrap p-r-5 p-l-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "var(--primary)",
                                          width: "100%",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Photo Slot Buttons
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.photos?.filter(
                                        (doc) => doc.photo_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          photo_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        // const matchingSlot = previousSlotData.find((item) =>
                                        //   item.slots?.some((slot) =>
                                        //     slot.docs?.some((doc) => doc.id === documentData.id)
                                        //   )
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.photos?.some((doc) => doc.id === documentData.id)
                                          );

                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.photos?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });

                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.photos?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            // const hasDocument = currentSlot.page_docs?.some(
                                            //   (doc) => doc.id === documentData.id
                                            // );
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.photos?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.photos?.some(
                                                (doc) => doc.id === documentData.id
                                              )
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    photos:
                                                      slot.photos?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        photos: [
                                                          ...(panel.photos?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      photos: [
                                                        ...(panel.photos || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          const pageNameToModelName = {
                                            treatment: "CaseProviders",
                                            defendant: "Defendant",
                                            witnesses: "Witness",
                                            insurance: "Insurance",
                                            parties: "OtherParty",
                                            reports: "Reports",
                                            employment: "Employment",
                                            loans: "CaseLoan",
                                            discovery: "Discovery",
                                            recording: "Recordings",
                                            experts: "CaseExpert",
                                            Litigation: "LitigationAct",
                                          };

                                          const modelName =
                                            pageNameToModelName[page?.name?.toLowerCase()];
                                          await api_without_cancellation.post(
                                            "api/attach_photo_to_page/",
                                            {
                                              panel_id: panel.id,
                                              slot_id: slot.id,
                                              page_id: page.id,
                                              case_id: documentData?.for_case?.id,

                                              photo_id: docId,
                                              ...(modelName && {
                                                model_name: modelName,
                                              }),
                                            }
                                          );
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-photos ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}
                                            {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  // height: "25px",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text whitespace-nowrap">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].title
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      // If no panels, show page slots directly
                      if (page_slots.length > 0 && !page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                // top:
                                //   width < 1920
                                //     ? `${index * 2 + 30}%`
                                //     : `${10 + index * 1.5}%`,
                                left: "auto",
                                top: "auto",
                                minWidth: "auto",
                                transform:
                                  width > 1920 ? "translate(0px, -20px)" : "translate(0px, -20px)",
                                right: width > 1920 ? "220px" : "220px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);

                                    const updatedDocumentData = {
                                      ...documentData,
                                      photo_slot: slot,
                                    };

                                    const matchingSlot = previousSlotData.find((item) => {
                                      // Check in slots
                                      const inSlots = item.slots?.some((slot) =>
                                        slot.photos?.some((doc) => doc.id === documentData.id)
                                      );

                                      if (inSlots) return inSlots;

                                      const inPanels = item.panels?.some((panel) =>
                                        panel.photos?.some((doc) => doc.id === documentData.id)
                                      );

                                      return inPanels;
                                    });

                                    const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                      panel.photos?.some((doc) => doc.id === documentData?.id)
                                    );

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.photos?.some((doc) => doc.id === documentData.id)
                                        );

                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.photos?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasPanel) {
                                          return {
                                            ...currentSlot,
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                photos:
                                                  slot.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => {
                                                if (panel.id === panelWithDocument?.id) {
                                                  return {
                                                    ...panel,
                                                    photos: [
                                                      ...(panel.photos?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || []),
                                                    ],
                                                  };
                                                }
                                                return panel;
                                              }) || [],
                                          };
                                        } else if (hasDocument) {
                                          // const filteredDocs = currentSlot.page_docs.filter(
                                          //   (doc) => doc.id !== documentData.id
                                          // );

                                          // return {
                                          //   ...currentSlot,
                                          //   slots: filteredDocs,
                                          // };
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                photos:
                                                  slot.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  photos: s.photos
                                                    ? [...s.photos, updatedDocumentData]
                                                    : [updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          // page_docs: currentSlot.page_docs
                                          //   ? [...currentSlot.page_docs, updatedDocumentData]
                                          //   : [updatedDocumentData],
                                        };
                                      }

                                      return currentSlot;
                                    });

                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post(
                                        "api/attach_photo_to_page/",
                                        {
                                          slot_id: slot.id,
                                          page_id: page.id,
                                          case_id: documentData?.for_case?.id,
                                          panel_id: null,
                                          photo_id: docId,
                                        }
                                      );
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error(error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}

                              <div
                                className="d-flex align-items-center bg-primary-5 justify-content-center"
                                style={{
                                  height: "25px",

                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap p-r-5 p-l-5"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  Photo Slot Buttons
                                </span>
                              </div>

                              {page_slots
                                .filter((slot) => slot.slot_number !== 0)
                                .map((slot, slotIndex) => {
                                  // const docsInSlot = slotData.page_docs?.filter(
                                  //   (doc) => doc.document_slot?.slot_number === slot?.slot_number
                                  // );
                                  const docsInSlot =
                                    slotData.slots
                                      ?.find((s) => s.slot_number === slot?.slot_number)
                                      ?.photos?.filter(
                                        (doc) => doc.photo_slot?.slot_number === slot?.slot_number
                                      ) || [];

                                  const handleClick = async () => {
                                    const previousSlotData = slotsData;
                                    const updatedDocumentData = {
                                      ...documentData,
                                      photo_slot: slot,
                                    };
                                    // const matchingSlot = previousSlotData.find((slot) =>
                                    //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                    // );

                                    // const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                    //   panel.documents?.some((doc) => doc.id === documentData?.id)
                                    // );
                                    const matchingSlot = previousSlotData.find((item) => {
                                      // Check in slots
                                      const inSlots = item.slots?.some((slot) =>
                                        slot.photos?.some((doc) => doc.id === documentData.id)
                                      );

                                      if (inSlots) return inSlots;

                                      const inPanels = item.panels?.some((panel) =>
                                        panel.photos?.some((doc) => doc.id === documentData.id)
                                      );

                                      return inPanels;
                                    });
                                    const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                      panel.photos?.some((doc) => doc.id === documentData?.id)
                                    );
                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.photos?.some((doc) => doc.id === documentData.id)
                                        );

                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.photos?.some((doc) => doc.id === documentData.id)
                                        );
                                        if (hasPanel) {
                                          return {
                                            ...currentSlot,
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                photos:
                                                  slot.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => {
                                                if (panel.id === panelWithDocument?.id) {
                                                  return {
                                                    ...panel,
                                                    photos: [
                                                      ...(panel.photos?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || []),
                                                    ],
                                                  };
                                                }
                                                return panel;
                                              }) || [],
                                          };
                                        } else if (hasDocument) {
                                          // const filteredDocs = currentSlot.page_docs.filter(
                                          //   (doc) => doc.id !== documentData.id
                                          // );

                                          // return {
                                          //   ...currentSlot,
                                          //   slots: filteredDocs,
                                          // };
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                photos:
                                                  slot.photos?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.id === slot.id) {
                                                return {
                                                  ...s,
                                                  photos: s.photos
                                                    ? [...s.photos, updatedDocumentData]
                                                    : [updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          // page_docs: currentSlot.page_docs
                                          //   ? [...currentSlot.page_docs, updatedDocumentData]
                                          //   : [updatedDocumentData],
                                        };
                                      }

                                      return currentSlot;
                                    });

                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post(
                                        "api/attach_photo_to_page/",
                                        {
                                          slot_id: slot.id,
                                          page_id: page.id,
                                          case_id: documentData?.for_case?.id,
                                          panel_id: null,
                                          photo_id: docId,
                                        }
                                      );
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error(error);
                                      setSlotsData(previousSlotData);
                                    }
                                  };

                                  return (
                                    <li
                                      key={slotIndex}
                                      className="d-flex align-items-center"
                                      style={{
                                        height: "25px",
                                        cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                        padding: "0px 10px",
                                      }}
                                      onClick={handleClick}
                                    >
                                      {slot.slot_number !== 0 && (
                                        <span className="d-flex align-items-center justify-content-center">
                                          {docsInSlot.length > 0 ? (
                                            <i
                                              className="ic ic-15 ic-photos cursor-pointer "
                                              style={{
                                                backgroundRepeat: "no-repeat",
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={UploadIcon}
                                              className=" ic-15 cursor-pointer"
                                              style={{
                                                backgroundRepeat: "no-repeat",
                                              }}
                                            />
                                          )}
                                        </span>
                                      )}

                                      {slot.slot_number !== 0 && (
                                        <div
                                          className={`d-flex align-items-center  ${
                                            docsInSlot.length === 0 ? "hoverable-text" : ""
                                          }`}
                                          style={{
                                            width: "calc(100% - 25px)",
                                            fontWeight: "bold",
                                            color:
                                              docsInSlot.length === 0
                                                ? "var(--primary-25)"
                                                : "inherit",
                                          }}
                                        >
                                          <>
                                            <span className="ms-2 hoverable-text">
                                              {slot.slot_number}.
                                            </span>
                                            <span className="ms-2 hoverable-text whitespace-nowrap">
                                              {docsInSlot.length > 0
                                                ? docsInSlot[0].title
                                                : slot.slot_name
                                                  ? slot.slot_name
                                                  : "Available"}
                                            </span>
                                          </>
                                        </div>
                                      )}
                                    </li>
                                  );
                                })}
                            </ul>
                          </li>
                        );
                      }
                    }

                    return null;
                  })}
              </ul>
            )}
          </div>
        </div>
        <div className="d-flex flex-column" style={{ gap: height <= 1024 ? "5px" : "40px" }}>
          <div
            className=""
            style={{
              display: height <= 1024 ? "flex" : "block",
              justifyContent: height <= 1024 ? "space-between" : "initial",
              background: "white",
              padding: "5px",
              gap: "5px",
            }}
          >
            {/* Chat Document Link Dropdown */}

            <div className="tile-row w-100 m-b-5  center-content my-auto">
              <div className="dropdown  d-flex">
                <button
                  className={
                    "btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn "
                  }
                  type="button"
                  // onClick={() => toggleDropdown("chatDoc")}
                  // onClick={handleShow}
                  aria-haspopup="true"
                  onClick={handleShow}

                  // aria-expanded={dropdownOpen.chatDoc}
                >
                  {/* <span className="has-no-after ic-arrow text-primary width-17 m-r-10 mega-hover-btn align-mid">
                    <svg
                      width="17"
                      height="23"
                      className=" "
                      viewBox="0 0 34 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.00683594 0H9.20684L17.0069 7.85384L24.807 0H34.007L17.0069 17L0.00683594 0Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span> */}
                  <span className="ic-15 d-flex align-items-center justify-content-center">
                    <NewChatIcon />
                  </span>
                  {height <= 1024 ? "Chat" : "Chat About Photo"}
                </button>
              </div>
            </div>

            {/* Link Doc to Task Dropdown */}

            {/* <div className="tile-row w-100 m-b-5  center-content my-auto">
              <div className="dropdown d-flex">
                <button
                  className={
                    "btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn "
                  }
                  type="button"
                  // onClick={() => toggleDropdown("taskLink")}
                  // onClick={handShowDocLinkModal}
                >
                  
                  <span className="ic-19 d-flex align-items-center justify-content-center">
                    <img
                      src="https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
                      className="ic ic-19 cursor-pointer img-19px d-flex align-items-center justify-content-center"
                    />
                  </span>
                  {height <= 900 ? "Task Link" : "Link Photo to Task"}
                </button>
              </div>
            </div> */}

            {/* Request Document Review Button */}

            <div className="tile-row w-100 m-b-5 center-content my-auto">
              <div className="dropdown d-flex">
                <button
                  className={
                    "btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn "
                  }
                  type="button"
                  // onClick={toggleModal}
                  aria-haspopup="true"
                  // aria-expanded={dropdownOpen.docReview}
                >
                  {/* <span className="has-no-after ic-arrow text-primary width-17 m-r-10 mega-hover-btn align-mid">
                    <svg
                      width="17"
                      height="23"
                      className=" "
                      viewBox="0 0 34 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.00683594 0H9.20684L17.0069 7.85384L24.807 0H34.007L17.0069 17L0.00683594 0Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span> */}
                  <span className="ic-15 d-flex align-items-center justify-content-center">
                    <img
                      src="https://simplefirm-bucket.s3.amazonaws.com/static/images/Tasks_page_icon_color.svg"
                      className="ic ic-15 cursor-pointer  d-flex align-items-center justify-content-center"
                    />
                  </span>

                  {height <= 1024 ? "Review" : "Request Photo Review"}
                </button>
              </div>
            </div>
          </div>
          <BottomContentSideBar
            docId={docId}
            documentURL={documentURL}
            file_name={file_name}
            imageRef={imageRef}
            documentURLfordownload={documentURLfordownload}
            isPdf={false}
            buttonData={buttonData}
            error={error}
          />
        </div>
        {showModal && (
          <ChatPhotoModal
            showModal={showModal}
            caseInfo={caseInfo}
            handleClose={handleClose}
            documentURL={documentURL}
            docName={file_name}
            documentData={documentData}
            firms={firms}
            selectedFirm={selectedFirm}
            users={users}
            loading={chatLoading}
            error={chatError}
            handleSelectFirm={handleSelectFirm}
            sendMessage={sendMessage}
            searchUsers={searchUsers}
            setChatDocumentThread={setChatDocumentThread}
            setUpdatedUser={setUpdatedUser}
            handleSelectUser={handleSelectUser}
          />
        )}
      </div>
    </div>
  );
};

DocumentModalSideBar.propTypes = {
  documentData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    for_client: PropTypes.object, // Define more specifically if possible
    for_case: PropTypes.shape({
      case_type: PropTypes.shape({
        name: PropTypes.string,
      }),
      incident_date: PropTypes.string,
    }),
    file_name: PropTypes.string,
    docDate: PropTypes.string,
    attached_by: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
    document_slot: PropTypes.object, // Define more specifically if possible
  }).isRequired,
};
export default DocumentModalSideBar;
